import { useDispatch, useSelector } from 'react-redux';
import DashboardEmptyStateCard from '../../DashboardEmptyStateCard';
import { toggleModal } from '@/store/slices/components/calendarEvents/CalendarEventsSlice';
import { getAgent } from '@/store/slices/components/calendarEvents/services';
import CalendarIcon from '@/public/images/dashboard/calendar.svg';
import Trans from '@/components/shared/Trans';
import translations from '../../Dashboard.trans.json';

function PendingEventsEmptyState() {
  const dispatch = useDispatch();
  const { selectedIds } = useSelector((state) => state.FilterBarSlice.filters);

  const handleClick = () => {
    dispatch(toggleModal());

    const ids = selectedIds.length > 0 ? selectedIds : null;
    if (ids) {
      dispatch(getAgent(ids));
    }
  };

  return (
    <DashboardEmptyStateCard
      icon={CalendarIcon}
      title={Trans(translations, 'HereYouWillSeeYourUpcomingEventsForTheDay')}
      description={Trans(translations, 'EachVisitIsKeyToClosingNewDeals')}
      buttonText={Trans(translations, 'CreateEvent')}
      onButtonClick={handleClick}
    />
  );
}

export default PendingEventsEmptyState;
